import React, {useEffect, useState} from 'react';
import ErrorIcon from '../Assets/SVG/ErrorIcon';
import BtnWhiteBlackBorderSmallSize from 'app/Components/Shared/Buttons/BtnWhiteBlackBorderSmallSize';
import BtnWhiteBlackBorderBigSize from 'app/Components/Shared/Buttons/BtnWhiteBlackBorderBigSize';
import {prepareSameWindowUrlWithNavigateTo} from 'app/utilities/StringHelpers/StringHelpers';
import Config from 'app/Config';
import RadiusErrorIcon from '../Assets/SVG/RadiusErrorIcon';
import AuthenticationProvider from 'app/utilities/authentication/authenticationProvider';

const ErrorScreen = (props) => {
  const displayNumberService = props.iContent.mokedNum?.value ? `${props.iContent.mokedNum?.value.replaceAll('*', '')}*` : '';
  const getTitle = () => {
    if (props.error.reservationError) {
      return <>לא מצאנו הזמנה על השם שלך</>;
    } else if (props.error.niudError) {
      return (
        <>
          משהו השתבש <br /> והניוד ל{window.Config.brand_Name_HE} לא הושלם
        </>
      );
    } else if (props.error.configError) {
      return (
        <>
          הניוד ל{window.Config.brand_Name_HE} בוצע אבל משהו <br />
          השתבש בדרך
        </>
      );
    } else if (props.error.radiusError) {
      return <>משהו לא עובד</>;
    }
    return null;
  };

  const getDescription = () => {
    if (props.error.reservationError) {
      return <>אולי נרשמת עם פרטים אחרים? </>;
    } else if (props.error.radiusError) {
      return <>כדי להשלים את ההתחברות אפשר להתקשר </>;
    } else {
      return (
        <>
          התרחשה תקלה בתהליך {props.error.errorNum && <>מספר {props.error.errorNum}</>} <br />
          נשמח לעזור לך לסיים את התהליך
        </>
      );
    }
  };

  const getErrorIcon = () => {
    if (props.error.radiusError) return <RadiusErrorIcon />;
    else return <ErrorIcon />;
  };
  return (
    <>
      {getErrorIcon()}
      <div className='headBox mb-12'>
        <p className='heading'>{getTitle()}</p>
        <p className='subHeading'>{getDescription()}</p>
      </div>
      <BtnWhiteBlackBorderBigSize
        text={props.error.reservationError ? 'התחברות מחדש' : `מעבר לנציג ${displayNumberService}`}
        onclick={() => {
          if (props.error.reservationError) {
            AuthenticationProvider.clearAuthenticationData();
            props.resetLoginData();
            authenticationProvider.redirectToLogin(location.pathname, '', '');
          } else {
            window.location.href = `tel:${props.iContent.mokedNum?.value}`;
          }
        }}
      />
      {props.error.reservationError && (
        <a
          href='#'
          className='supportLink mt-24'
          onClick={() => {
            window.location.href = `tel:${props.iContent.mokedNum?.value}`;
          }}>
          מעבר לנציג {displayNumberService}
        </a>
      )}
      {!props.error.reservationError && (
        <div className='fixFooter'>
          <BtnWhiteBlackBorderBigSize
            text='סיום'
            onclick={() => {
              prepareSameWindowUrlWithNavigateTo(Config.lobbyUrl);
            }}
          />
        </div>
      )}
    </>
  );
};

export default ErrorScreen;
